export default "__VITE_ASSET__Bkik3iEK__"